import { Component } from '@angular/core';
@Component({
  template: '',
})
export class Sort {
  ngOnInit(): void {}
  sortTable(data, type, isAscending, column) {
    let total;
    data.map((value: any, index: number) => {
      if (value.hierarchy == 'Total') {
        total = data[data.length - 1];
        data.splice(-1);
      }
    });

    if (type == 'integer') {
      data.sort((a: any, b: any) =>
        isAscending ? a[column] - b[column] : b[column] - a[column]
      );
    } else {
      data.sort((a: any, b: any) =>
        (
          isAscending
            ? a[column].toLowerCase() > b[column].toLowerCase()
            : b[column].toLowerCase() > a[column].toLowerCase()
        )
          ? 1
          : -1
      );
    }
    if (total) {
      data.push(total);
    }
    console.log(data);
    return data;
  }
}
